import React from 'react';
export function Header() {
  return <header className="bg-warm-bg/95 backdrop-blur-sm sticky top-0 z-40 border-b border-warm-alt/50" data-id="element-154">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-center" data-id="element-155">
        <a href="#" className="flex items-center" data-id="element-156">
          <img src="https://cdn.magicpatterns.com/uploads/8XezKwaD9LGnpzQL9aUbLz/FEB522F3-9C04-4F3B-A005-C6C7F980373E.png" alt="Espalda Libre" className="h-20 md:h-24 w-auto object-contain" data-id="element-157" />
        </a>
      </div>
    </header>;
}